module.exports = __webpack_public_path__ + "static/img/coding.8252634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coding.png
// module id = 50
// module chunks = 2